<template>
  <div  :class="routeName=='index'?'marn-b80':'marn-b80'">
    <div class="bg">
      <div class="headerBox">
          <div class="header">
              <div class="logo">
                <router-link :to="{ path: '/' }">
                  <img src="../assets/newlogo.png" alt />
                </router-link>
              </div>
              <div class="search-box">
                <div class="search">
                  <el-input
                    class="input"
                    v-model="keyword"
                    @keyup.enter.native="searchGoods"
                  >
                  </el-input>
                  <button class="searchBtn" @click="searchGoods"></button>
                </div>
              </div>
              <div class="login-box">
                <img
                    src="../assets/login.png"
                    alt="登陆"
                    v-if="!$store.state.user.username"
                    class="common-btn-text loginBtn"

                    @click="
                      dialogVisible = true;
                      form.password = '';
                    "
                  />
                <img
                    src="../assets/regist.png"
                    alt="注册"
                    @click="$router.push('/regist')"
                    v-if="!$store.state.user.username"
                    class="common-btn-text registerBtn"

                  />
                <button
                  v-if="$store.state.user.username"
                  class="common-btn-text"
                  style="color: #333"
                  @click="$router.push('/user/home')"
                >
                  {{ $store.state.user.username }}
                </button>
                <button
                  v-if="$store.state.user.username"
                  class="common-btn-text"
                  style="color: #333"
                  @click="logout()"
                >
                  退出登录
                </button>
                <!-- $store.state.user.cartData -->
              </div>
              <div class="shopping-carte">
                <img
                  src="../assets/cart1.png"
                  alt="购物车"
                  @click="$router.push('/cart')"

                />
                <span v-if="$store.state.user.cartData > 0">{{$store.state.user.cartData}}</span>
              </div>
            </div>
      </div>
      <div class="goods-type-bg">
        <div class="goods-type">
          <el-menu class="el-menu-nav" mode="horizontal" @select="gotoType">
            <el-submenu
              v-for="(item, index) in $store.state.category.tree"
              :key="index"
              :index="item.id + ''"
              :popper-class="['my-el-menu', 'my-el-menu-'+index]"
              :class="[(categoryPath.length>0 && categoryPath[0].id==item.id) ? 'f' : '']"
              @click.native="submenuClick(item.id)"
            >
              <!-- 一级菜单点击事件 -->
              <template slot="title">{{ item.name}}</template>
              <template v-for="z in item.children">
                <el-menu-item :index="z.id + ''" :key="z.id" :class="['goods-type-color'+index, (category==z.id) && 'f']">{{ z.name }}</el-menu-item>
                <!-- 三级菜单 -->
                <!-- <el-menu-item v-if="!z.children" :index="z.id+''" :key="z.id">{{z.name}}</el-menu-item>
              <el-submenu v-else :key="z.id" :index="z.id+''" @click.native="submenuClick(z.id)">
                <template slot="title">{{z.name}}</template>
                <el-menu-item v-for="x in z.children" :index="x.id+''" :key="x.id">{{x.name}}</el-menu-item>
                </el-submenu>-->
              </template>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <el-dialog
        title="欢迎登录库蜂网"
        :visible.sync="dialogVisible"
        width="540px"
        :modal-append-to-body="false"
      >
        <el-tabs :tab-position="tabPosition" class="login-tab">
          <el-tab-pane label="账号登录">
            <el-form :model="form" :rules="loginRules" ref="userForm">
              <el-form-item
                label="用户名:"
                :label-width="labelWidth"
                prop="username"
              >
                <el-input v-model="form.username" placeholder="请输入用户名">
                  <el-button slot="prepend" icon="el-icon-user"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item
                label="密码:"
                :label-width="labelWidth"
                prop="password"
              >
                <el-input
                  @keyup.enter.native="login"
                  type="password"
                  v-model="form.password"
                  placeholder="请输入密码"
                >
                  <el-button slot="prepend" icon="el-icon-key"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item class="login-button">
                <el-button type="primary" @click="userLogin('userForm')"
                  >登 录</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="短信登录">
            <el-form :model="form" :rules="telphoneRules" ref="telphoneForm">
              <el-form-item
                label="手机号:"
                :label-width="labelWidth"
                prop="telphone"
              >
                <el-input
                  v-model="form.telphone"
                  :maxlength="11"
                  autocomplete="off"
                >
                  <el-button slot="prepend" icon="el-icon-phone"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item
                label="验证码:"
                :label-width="labelWidth"
                prop="checkCode"
              >
                <el-input
                  style="width: 180px"
                  @keyup.enter.native="login"
                  v-model="form.checkCode"
                  autocomplete="off"
                >
                  <el-button slot="prepend" icon="el-icon-message"></el-button>
                </el-input>
                <button
                  type="button"
                  class="common-btn"
                  :disabled="state.smsSendBtn"
                  @click.stop.prevent="getCheckCode"
                  v-text="
                    (!state.smsSendBtn && '获取验证码') || state.time + ' s'
                  "
                  style="margin-left:25px;"
                >
                  >获取验证码
                </button>
              </el-form-item>
              <el-form-item class="login-button">
                <el-button type="primary" @click="phoneLogin('telphoneForm')"
                  >登 录</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="忘记密码">
            <div class="forget-password">
              <div>
                <el-steps :active="step" finish-status="success">
                  <el-step title="身份验证"></el-step>
                  <el-step title="更改密码"></el-step>
                  <el-step title="完成"></el-step>
                </el-steps>
              </div>
              <el-form
                :model="form"
                v-show="step === 0"
                :rules="telphoneRules"
                ref="nextForm"
              >
                <el-form-item
                  label="手机号:"
                  :label-width="labelWidth"
                  prop="telphone"
                >
                  <el-input
                    v-model="form.telphone"
                    :maxlength="11"
                    autocomplete="off"
                  >
                    <el-button slot="prepend" icon="el-icon-phone"></el-button>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="验证码:"
                  :label-width="labelWidth"
                  prop="checkCode"
                >
                  <el-input
                    style="width: 180px"
                    @keyup.enter.native="login"
                    v-model="form.checkCode"
                    autocomplete="off"
                  >
                    <el-button
                      slot="prepend"
                      icon="el-icon-message"
                    ></el-button>
                  </el-input>
                  <button
                    type="button"
                    class="common-btn"
                    :disabled="state.smsSendBtn"
                    @click.stop.prevent="getCheckCode"
                    v-text="
                      (!state.smsSendBtn && '获取验证码') || state.time + ' s'
                    "
                    style="margin-left:25px;"
                  >
                    >获取验证码
                  </button>
                </el-form-item>
                <el-form-item class="login-button">
                  <el-button type="primary" @click="nexStep('nextForm')"
                    >下一步</el-button
                  >
                </el-form-item>
              </el-form>
              <el-form
                :model="form"
                v-show="step === 1"
                :rules="passwordRules"
                ref="passwordForm"
              >
                <el-form-item
                  label="新密码:"
                  :label-width="labelWidth"
                  prop="password"
                >
                  <el-input
                    type="password"
                    v-model="form.password"
                    placeholder="请输入新密码"
                  >
                    <el-button slot="prepend" icon="el-icon-key"></el-button>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="确认密码:"
                  :label-width="labelWidth"
                  prop="rePassword"
                >
                  <el-input
                    type="password"
                    v-model="form.rePassword"
                    placeholder="请再次输入新密码"
                  >
                    <el-button slot="prepend" icon="el-icon-key"></el-button>
                  </el-input>
                </el-form-item>
                <el-form-item class="login-button">
                  <el-button
                    type="primary"
                    @click="updatePassword('passwordForm')"
                    >修改密码</el-button
                  >
                </el-form-item>
              </el-form>
              <el-form :model="form" v-show="step === 2">
                <p style="font-size: 24px; text-align: center">
                  修改密码成功！
                </p>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>
    <div style="height: 122px"></div>
  </div>
</template>

<script>
import { timeFix, validatePsdReg, validatePhone } from "@/utils/util";
import {
  login,
  categoryTree,
  getCheckCode,
  phoneLogin,
  checkCode,
  updatePassword,
} from "../js/api";

import { mapActions } from "vuex";
export default {
  name: "header-nav",
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      tabPosition: "bottom",
      dialogVisible: false,
      labelWidth: "120px",
      keyword: this.$route.query.keyword || "",
      category: this.$route.query.category || "",
      categoryPath: [],
      form: {
        username: "",
        password: "",
        rePassword: "",
        telphone: "",
        checkCode: "",
      },
      state: {
        time: 300,
        smsSendBtn: false,
      },
      isPhoneLogin: false,
      step: 0,
      loginRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      telphoneRules: {
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        checkCode: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ],
      },
      passwordRules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePsdReg, trigger: "blur" },
        ],
        rePassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      routeName:''
    };
  },
  mounted() {
    console.log('第一次载入')
    this.routeName = this.$route.name
    categoryTree().then((res) => {
      if (res.code == 0) {
        const typeList = res.result;
        typeList.map((z) => {
          z.title = z.name;
          z.value = z.id;
          if (z.parentId) {
            for (let i in typeList) {
              if (typeList[i].id === z.parentId) {
                if (typeList[i].children) typeList[i].children.push(z);
                else typeList[i].children = [z];
              }
            }
          }
        });
        for (let i = 0; i < typeList.length; i++) {
          if (typeList[i].parentId !== 0) {
            typeList.splice(i, 1);
            i--;
          }
        }
        this.$store.commit("SET_CATE_DATA", typeList);
      }
    });
  },
  watch: {
    $route: function (to, old) {
      this.routeName = to.name
      this.getCategoryPath();
      if (to.name == "regist" && to.query.login) {
        this.dialogVisible = true;
        this.$router.replace("./regist");
      }
      if (!to.query.category) {
        this.categoryPath = []
      }
    },
    "$store.state.category.tree": function() {
      this.getCategoryPath();
    }
  },
  methods: {
    ...mapActions(["Login", "Logout", "PhoneLogin"]),
    getCheckCode() {
      if (this.form.telphone) {
        getCheckCode({
          telphone: this.form.telphone,
          type: "LOGIN",
        }).then((res) => {
          if (res.code == 0) {
            this.state.smsSendBtn = true;
            let interval = window.setInterval(() => {
              if (this.state.time-- <= 0) {
                this.state.time = 300;
                this.state.smsSendBtn = false;
                window.clearInterval(interval);
              }
            }, 1000);
            // this.$message.success("验证码：" + res.result);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("请输入手机号码");
      }
    },
    getCategoryPath() {
      const category = this.$route.query.category;
      if (!category) return;
      const tree = this.$store.state.category.tree;
      if (!tree) return;
      const data = this.searchData(tree, category);
      this.categoryPath = data;
    },
    searchData(treeList, val) {
      for (let i = 0; i < treeList.length; i++) {
        if (treeList[i].id == val) return [treeList[i]];
        else if (treeList[i].children) {
          const res = this.searchData(treeList[i].children, val);
          if (res.length > 0) return [treeList[i]].concat(res);
        }
      }
      return [];
    },
    gotoType(e) {
      this.$router.push(`/goodslist?category=${e}`);
      this.category = e
    },
    submenuClick(e) {
      this.gotoType(e);
    },
    userLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.Login(this.form).then((res) => {
            this.dialogVisible = false;
            this.$notify({
              title: timeFix() + ", " + this.$store.state.user.username,
              message: this.$store.state.user.welcome,
              type: "success",
            });
            if (this.$route.name === "regist") {
              // 从注册页面回到首页
              this.$router.push("/");
            } else {
              location.reload();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    phoneLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.PhoneLogin(this.form)
            .then((res) => {
              this.dialogVisible = false;
              this.$notify({
                title: timeFix() + ", " + this.$store.state.user.username,
                message: this.$store.state.user.welcome,
                type: "success",
              });
              if (this.$route.name === "regist") {
                // 从注册页面回到首页
                this.$router.push("/");
              } else {
                location.reload();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    nexStep(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          checkCode({
            telphone: this.form.telphone,
            code: this.form.checkCode,
          })
            .then((res) => {
              if (res.success) {
                this.step = 1;
              } else {
                this.$message.warning(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    updatePassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          updatePassword(this.form)
            .then((res) => {
              if (res.success) {
                this.step = 2;
              } else {
                this.$message.warning(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    logout: function () {
      this.Logout().then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    searchGoods: function (e) {
      let path = `/goodslist?keyword=${this.keyword}`;
      // if (this.$route.path.includes("goodslist"))
      //   path += `&category=${this.category}`;
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.search .input :deep .el-input__inner {
  padding-right: 0;
  height: 28px;border: none;
}
.search .input :deep .el-input__suffix {
  /* line-height: 48px;
  height: 48px; */
  left: 30px;
}

.el-tab-pane{padding-right: 60px;}
.login-tab :deep .el-tabs__content {
  margin-top: -20px;
  padding-top: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-tab :deep .el-tabs__nav {
  margin-left: 125px;
}
.login-tab :deep .el-tabs__nav-scroll {
  text-align: center;
}

.login-button :deep{
  margin-left: 120px;
  .el-button--primary {
    width: 100%;
  }
}
.forget-password :deep .el-steps {
  padding: 0px 40px 20px 40px;
}
.forget-password :deep .el-step__title {
  font-size: 12px;
}
</style>
<style lang="less" scoped>
.bg {
  position: fixed;
  z-index: 100;
  width: 100%;
  border-top: 40px solid rgb(99, 198, 149);
  // background-color: #ffe001;
}
.headerBox{
  width: 100%;
  background-color: #f8f8f8;
}
.header {
  display: flex;
  width: 1060px;
  margin: auto;
  height: 90px;
  align-items: center;
  padding-left: 10px;

  > div{display: flex;align-items: center;margin-top: 10px;height: 80px;}
  > div:first-child, > div:last-child{height: 90px;margin-top: 0;}

  .logo img {
    width: 160px;
    height: 50px;
  }
  .search-box{
    margin-left: 40px;width: 460px;
    .search {
      position: relative;width: 100%;
      z-index: 3;border: 1px solid #666;height: 28px;border-radius: 28px;overflow: hidden;display: flex;justify-content: space-between;
      .el-input__suffix{
        right: 225px;
      }
      .el-icon-search:before{
        font-size: 28px;
        position: absolute;
        left: 0;
        color: #666;
      }
      .searchBtn{
        outline: none;
        border: none;
        background: url(../assets/searchIcon.png) center no-repeat #666;margin: 1px 2px;background-size: 80%;
        color: #fff;
        font-size: 18px;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        width: 60px;
        border-radius: 26px;
        height: 26px;
      }
    }
  }

  .login-box {
    flex: 1;
    justify-content: end;margin-right: 20px;
    .loginBtn,.registerBtn{
      margin: 0 16px;
    }
    button ~ button {
      margin-left: 12px;
    }
    img {
      height: 16px;
      display: inline-block;
      font-size: 24px;
      color: #fff;
      cursor: pointer;
      margin: 0 6px;
    }
  }
  .shopping-carte{
    position: relative;
    img{height: 32px;}
    span{position: absolute;right: -4px;border-radius: 50%;background-color: red;color: #fff;width: 16px;height: 16px;line-height: 16px;text-align: center;font-size: 12px;transform: translate(0, -14px);}
  }
}

.forget-password {
  padding: 10px;
  width: 100%;
  margin: auto;
  .form {
    margin-top: 5px;
    width: 100%;
  }
}
</style>
